import { Box } from '@mui/material';
import React from 'react';

import { TJobDifferencesProps } from '@/console/features/jobs/components/job-differences/job-differences.types';
import { MarkdownReader } from '@/shared/components/ui/markdown-reader/markdown-reader';

export const JobDifferences: React.FC<TJobDifferencesProps> = ({
  differences,
  editorHeight,
}) => {
  if (!differences || differences.length === 0) {
    return null;
  }

  return (
    <Box
      position="relative"
      height={editorHeight ?? 'calc(100vh - 8.5rem)'}
      overflow="auto"
    >
      <MarkdownReader content={differences} />
    </Box>
  );
};
